import {Action} from '@ngrx/store';
import {ArrayResponse, type} from '../../shared';
import {Address, AddressSummaries} from '../../shared/models/address';
import {ShippingsList} from '../models/shippings-list';

export const addressSummariesActionTypes = {
  LOAD: type('[Address Summaries] Load'),
  LOAD_SUCCESS: type('[Address Summaries] Load Success'),
  LOAD_FAIL: type('[Address Summaries] Load Fail'),
  CLEAR: type('[Address Summaries] Clear')
};

export class LoadAddressSummariesAction implements Action {
  readonly type = addressSummariesActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadAddressSummariesSuccessAction implements Action {
  readonly type = addressSummariesActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ArrayResponse<AddressSummaries>) {}
}

export class LoadAddressSummariesFailAction implements Action {
  readonly type = addressSummariesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}

export class LoadAddressSummariesClearAction implements Action {
  readonly type = addressSummariesActionTypes.CLEAR;
  constructor() {}
}
